import * as THREE from 'three';
import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter.js';
import { downloadFile } from './downloadFile';

/** Exports the given mesh as a Wavefront .obj file. */
export function exportOBJ(mesh: THREE.Object3D, fileName: string): void {
  const exporter = new OBJExporter();
  const result = exporter.parse(mesh);
  downloadFile(result, fileName, 'text/plain');
}
